import React, { useState, useEffect, useRef, useContext } from "react";
import { Stage, Layer, Line } from "react-konva";
import { Dropdown, DropdownButton, Button, Container, Modal, Row, Col, Table, ButtonGroup } from 'react-bootstrap';
import { C4FStatusContext } from "../main/App";
import { ReferenceDataContext } from "../main/App";
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import { UserInformationContext } from "../main/App";
import { getJersey } from "./C4FLeaderJerseys";
import config from "../etc/config.json";
import '../css/Race.css';
import { currentISODate, formatTimeSeconds, formatTimeShort, RiderImage, getJerseyForRacer } from "../common/Helpers";

function ReplayModal(props) {

    const { countries } = useContext(ReferenceDataContext);
    const { userInformation } = useContext(UserInformationContext);
    const { handleBackendRequest } = useContext(C4FStatusContext);
    const mounted = useRef(false);
    const [show, setShow] = useState(false);
    const [replayType, setReplayType] = useState('race');
    const handleClose = () => props.handleClose();
    const [race, setRace] = useState(null);
    const [selectedStageNumber, setSelectedStageNumber] = useState(null);
    const [replays, setReplays] = useState([]);
    const [allRacers, setAllRacers] = useState(null);    
    const [selectedSector, setSelectedSector] = useState(1);
    const [raceReport, setRaceReport] = useState('');

    const [sprint, setSprint] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(0);
    const [selectedStep, setSelectedStep] = useState(10);
    const [sprintDisplayAttributes, setSprintDisplayAttributes] = useState(null);
    const [sprintAnimation, setSprintAnimation] = useState(null);
    const sprintRef = useRef();
    const scrollRight = () => sprintRef.current?.scrollTo(100000, 0);



    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            setShow(props.show);
            if (!race && props.show) loadRaceDetails();
            let finishedRacers = props.raceEdition.groups.length > 0 ? props.raceEdition.groups[0].racers : [];
            let disqualifiedRacers = props.raceEdition.groups.length > 1 ? props.raceEdition.groups[1].racers : [];
            setAllRacers(finishedRacers.concat(disqualifiedRacers));
        }
        else {
        }
    }, [props.show]);


    useEffect(() => {
        scrollRight();
    }, [selectedStep, selectedGroup]);

    useEffect(() => {
        if (show &&
            sprintAnimation !== null &&
            sprintAnimation.positions.length > 0 &&
            sprintAnimation.step < sprintAnimation.positions[0].positions.find(p => p.step === selectedStep).positions.length - 1)
            setTimeout(function () {
                setSprintAnimation({ step: sprintAnimation.step + 1, positions: sprintAnimation.positions })
            }, 100);
    }, [sprintAnimation]);



    function loadRaceDetails() {
        handleBackendRequest('GET', '/race/' + props.raceEdition.race.id, null, null, function(race) {
            setRace(race);
            if (props.raceEdition.status === 'Completed')
                handleSetStage(race, race.numberOfStages);
            else if (props.raceEdition.sprintStatus === 'Completed')
                handleSetStage(race, props.raceEdition.currentStage);
            else
                handleSetStage(race, Math.max(props.raceEdition.currentStage - 1, 1));
            }
        );
    }

    function handleSetStage(race, stageNumber) {
        stageNumber = Number(stageNumber);
        if (replays && replays.some(r => r.stageNumber === stageNumber)) {
            setSelectedStageNumber(stageNumber);
        }
        else {
            handleBackendRequest('GET', '/raceEdition/' + props.raceEdition.id + '/replay', null, { stageNumber: stageNumber }, function(replayObject) {                
                let finishedRacers = props.raceEdition.groups.length > 0 ? props.raceEdition.groups[0].racers : [];
                let disqualifiedRacers = props.raceEdition.groups.length > 1 ? props.raceEdition.groups[1].racers : [];
                let allRacers = finishedRacers.concat(disqualifiedRacers);        
                replayObject.replay = replayObject.replay.map(sector => sector.map(rider => ({
                    ...rider,
                    racerIndex: allRacers.some(racer => racer.rider.id === rider.riderId) ?
                        allRacers.findIndex(racer => racer.rider.id === rider.riderId)
                        :
                        null
                })));

                let replaysToSet = replays.concat([replayObject]);
                setReplays(replaysToSet);
                setSelectedStageNumber(stageNumber);
                handleSetSector(replaysToSet, stageNumber, 1);
                prepareSprint(race, allRacers, replayObject.sprint);
            },
            true,
            function() {
                setReplays(replays.concat([{ stageNumber: stageNumber, replay: null, raceReport: null }]));
            },
            true);
        }
    }

    function getRacerNameAndJersey(racer) {
        return <>
          {racer.rider.firstNames + '\xa0' + racer.rider.lastNames}
          {(racer.raceJersey !== 'None') ?
              <img alt={racer.raceJersey} title={racer.raceJersey} 
                src={getJersey('recurringEvent' in props.raceEdition.race ? props.raceEdition.race.recurringEvent : props.raceEdition.race.raceName, racer.raceJersey)} 
                style={{ maxHeight: "18px" }} />
            :
            racer.rider.jerseys.map(jersey => (
              <img alt={jersey} title={jersey} 
                src={getJersey('recurringEvent' in props.raceEdition.race ? props.raceEdition.race.recurringEvent : props.raceEdition.race.raceName, jersey)} 
                style={{ maxHeight: "18px" }} />
            ))}
        </>
      }
    
    function handleSetSector(replays, stageNumber, sector) {
        let selectedReplay = replays.find(r => r.stageNumber === stageNumber);
        if (!selectedReplay) return;
        let sectorToSet = sector;
        if (sector < 1) sectorToSet = 1;
        if (sector > selectedReplay.replay.length) sectorToSet = selectedReplay.replay.length;
        setSelectedSector(sectorToSet);
        let fullRaceReport = selectedReplay.raceReport;
        setRaceReport(fullRaceReport.substring(fullRaceReport.indexOf('Km: ' + sectorToSet + ',')));
    }

    function linearInterpolation(values, additionalValues) {
        values = values.map(v => Math.floor(v));
        let output = []
        for(let i = 0; i < values.length - 1; i++) {
            output.push(values[i]);
            for(let j = 1; j <= additionalValues; j++)
                output.push(values[i] + (values[i + 1] - values[i]) * j / additionalValues);
        }
        output.push(values[values.length - 1]);
        return output;
    }

    function getDetailedSprintPositions(from, to) {
        let x = linearInterpolation([from.x, to.x], 10);
        let y = linearInterpolation([from.y, to.y], 10);
        let output = [];
        for (let i = 0; i < x.length; i++)
            output.push({
                x: x[i],
                y: y[i]            
            });
        return output;
    }

    function getSprintPositionsForRacer(sprint, racer) {
        let positions = [];
        let previousPosition = {
            x: 0,
            y: 0
        };
        let racerSprinted = sprint.some(sprintStep => sprintStep.positions.some(p => p.riderId === racer.rider.id));
        
        if (racerSprinted)
            sprint.forEach(sprintStep => {
                let racerSprintForStep = sprintStep.positions.find(p => p.riderId === racer.rider.id);
                if (racerSprintForStep) {
                    let currentPosition = {
                        step: sprintStep.sprintStep,
                        positions: getDetailedSprintPositions({ x: previousPosition.x, y: previousPosition.y }, { x: racerSprintForStep.positionX, y: racerSprintForStep.positionY }),
                    }
                    positions.push(currentPosition);
                    previousPosition = {
                        x: racerSprintForStep.positionX,
                        y: racerSprintForStep.positionY
                    }
                }
            });
        return positions;
    }

    function prepareSprint(race, racers, sprint) {
        // let latestStep = 10;
        let sprintPositions = racers.map(racer => ({
            id: racer.rider.id,
            group: racer.gapCurrentStage,
            name: racer.rider.lastNames,
            number: racer.number,
            jersey: getJerseyForRacer(countries, racer, props.raceEdition.teams.find(t => t.id === racer.racerTeamId).team, race),
            sprintSkill: racer.rider.skills.Sprint,
            positions: getSprintPositionsForRacer(sprint, racer)
        }));
        if (sprintPositions.every(sp => sp.positions.length === 0))
            setSprint(null);
        else {            
            setSprint(sprintPositions);
            handleSetSprintSituation(10, 0, sprintPositions);
            scrollRight();
        }
    }

    function handleSetSprintSituation(step, group, sprintPositions = null) {
        // handle call on initialization vs after loading
        if (sprintPositions === null) sprintPositions = sprint;

        let allXPositions = [];
        let relevantPositions = sprintPositions.filter(s => s.group === group && s.positions.length > 0);
        relevantPositions.forEach(s => s.positions
            .find(p => p.step === step).positions
            .forEach(p => allXPositions = allXPositions.concat(p.x)));        

        setSprintDisplayAttributes({
            step: step,
            group: group,
            xMax: Math.max(...allXPositions),
            xMin: Math.min(...allXPositions)
        });
        setSelectedGroup(group);
        setSelectedStep(step);
        setSprintAnimation({ step: 0, positions: relevantPositions });
    }

    return <>
        <Modal key={'replayModal' + show} size="xl" show={show} onHide={handleClose} >
            <Modal.Header>
                <Modal.Title>Replay</Modal.Title>
                <Button className="py-0 m-0" variant="danger" onClick={handleClose}>{'X'}</Button>
            </Modal.Header>
            <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)', padding: 0, margin: 0 }}>
                {race && replays ?
                    <>
                        <Container className="p-0 m-0">
                            <Row className="justify-content-center">
                                <Col>
                                    <ButtonGroup className="m-1" size="sm">
                                        <DropdownButton size="sm" variant={'outline-secondary'}
                                            title={race.stages.some(s => s.number === selectedStageNumber) ? 
                                                selectedStageNumber + ' - ' + race.stages.find(s => s.number === selectedStageNumber).name
                                                : 'unknown'}
                                            onSelect={(selectedStage, e) => handleSetStage(race, selectedStage)}>
                                        {race.stages.filter(s => s.raceType !== 'RestDay').map(s => 
                                            <Dropdown.Item disabled={props.raceEdition.status !== 'Completed' && props.raceEdition.currentStage < s.number} 
                                                eventKey={s.number}>{s.number + ' - ' + s.name}</Dropdown.Item>)}
                                        </DropdownButton>
                                    </ButtonGroup>
                                    <ButtonGroup size="sm">
                                        <Button variant={(replayType === 'race' ? '' : 'outline-') + 'secondary'} 
                                            onClick={() => setReplayType('race')}>Race</Button>
                                        <Button variant={(replayType === 'sprint' ? '' : 'outline-') + 'secondary'} 
                                            disabled={!sprint || sprint.length === 0}
                                            onClick={() => setReplayType('sprint')}>Sprint</Button>
                                    </ButtonGroup>
                                    {replayType === 'race' ?
                                        <ButtonGroup className="m-1" size="sm">
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, 1)}>{'|\u25C0'}</Button>
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, selectedSector - 5)}>{'\u25C0\u25C0'}</Button>
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, selectedSector - 1)}>{'\u25C0'}</Button>
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, selectedSector + 1)}>{'\u25B6'}</Button>
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, selectedSector + 5)}>{'\u25B6\u25B6'}</Button>
                                            <Button variant={'outline-secondary'} onClick={() => handleSetSector(replays, selectedStageNumber, 1000)}>{'\u25B6|'}</Button>
                                        </ButtonGroup>                                
                                        :
                                        <ButtonGroup className="m-1" size="sm">
                                        {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map(step =>
                                            <Button variant={step === selectedStep ? 'secondary' : 'outline-secondary'}
                                                disabled={!sprint.some(sp => sp.positions.length > 0 && sp.positions.some(p => p.step === step))}
                                                onClick={() => handleSetSprintSituation(step, selectedGroup)}>{step * 50}m</Button>
                                        )}
                                        </ButtonGroup>
                                    }
                                </Col>
                            </Row>
                            {replayType === 'race' &&
                            replays.some(r => r.stageNumber === selectedStageNumber) && 
                            replays.find(r => r.stageNumber === selectedStageNumber).replay && 
                            selectedSector <= replays.find(r => r.stageNumber === selectedStageNumber).replay.length ?
                                <>
                                    <Row className="justify-content-center">
                                        <Col className="border border-secondary m-1 p-1" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                                            <div className="vl" style={{ height: "225px", maxHeight: "100%", borderLeft: "2px solid blue", position: "absolute", left: 0.45 + ((30 / 7.46) + (selectedSector / race.stages.find(s => s.number === selectedStageNumber).length) * (((746 - 45) / 7.46) - 0.45)) + "%" }}></div>
                                            <img style={{ maxHeight: "100%", maxWidth: "100%" }}
                                                alt="profile needs to be shown here"
                                                src={config.DIR_PROFILES + race.stages.find(s => s.number === selectedStageNumber).profileCode + ".png?" + currentISODate}></img>
                                        </Col>
                                    </Row>
                                    <Row className="p-1 m-1" style={{ height: "550px", overflow: "auto", fontSize: "0.875em", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                                        <Table size="sm" >
                                            <thead>
                                                <tr className="table-secondary">
                                                    <th className="th-race sortable" style={{ paddingRight: "5px" }}>Nr</th>
                                                    <th className="th-race sortable" style={{ textAlign: "left" }}>Rider</th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                                                    <th className="th-race sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                                                    <th className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Time</th>
                                                    <th className={race.stages.length > 1 ? 'th-race sortable' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Virtual</th>
                                                    <th className="th-race" scope="col">Tempo</th>
                                                    <th className="th-race sortable" scope="col">Team</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {replays.find(r => r.stageNumber === selectedStageNumber).replay[selectedSector - 1]
                                                    .map(racer =>
                                                        racer.racerIndex !== null ?
                                                            <tr className={racer.racerGroup % 2 === 0 ? '' : 'tr-race-alternatingColour'}>
                                                                <td className="td-race">{allRacers[racer.racerIndex].number}</td>
                                                                <td className={'td-race-rider ' + (userInformation.userId === allRacers[racer.racerIndex].rider.owner ? 'td-race-ownRider' : '')} >
                                                                    {getRacerNameAndJersey(allRacers[racer.racerIndex])}
                                                                </td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.Climbing}</td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.Flat}</td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.Downhill}</td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.TimeTrial}</td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.Sprint}</td>
                                                                <td className="td-race">{Math.round((allRacers[racer.racerIndex].rider.skills.Cobbles * 0.3 + allRacers[racer.racerIndex].rider.skills.Flat * 0.7) * 10) / 10}</td>
                                                                <td className="td-race">{allRacers[racer.racerIndex].rider.skills.Regeneration}</td>
                                                                <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{racer.gapCurrentStage}</td>
                                                                <td className={(props.raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{racer.gapOverallVirtual}</td>
                                                                <td className="td-race">
                                                                    {racer.tempoSuccess === 'None' ?
                                                                        'None'
                                                                        :
                                                                        <Button disabled className="py-0" size="sm" variant={
                                                                            (racer.tempoSuccess === 'NoSuccess' ? 'outline-' : '') +
                                                                            (racer.tempoIntensity === 'Green' ? 'success' : '') +
                                                                            (racer.tempoIntensity === 'Blue' ? 'primary' : '') +
                                                                            (racer.tempoIntensity === 'Red' ? 'danger' : '')} >Tempo</Button>
                                                                    }
                                                                </td>
                                                                <td className="td-race" style={(userInformation.userId === allRacers[racer.racerIndex].rider.owner) ? { fontWeight: "bold" } : {}}>{allRacers[racer.racerIndex].rider.ownerName}</td>
                                                            </tr>
                                                            :
                                                            null
                                                    )
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                    <Row className="p-1 m-0 justify-content-center">
                                        <Col className="col-8 border border-secondary m-0 px-2"
                                            style={{ height: 150, overflow: "auto", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
                                            {raceReport.split('\n').map((item, key) => 
                                                <p className="text-justify my-0 p-0" key={key} style={{ fontSize: "0.8em" }}>{item}<br /></p>
                                            )}
                                        </Col>
                                    </Row>
                                </>
                            : null }
                        </Container>
                    </>

                    : null
                }
                {replayType === 'sprint' && sprint.length > 0 && sprintDisplayAttributes && sprintAnimation ?
                    <>
                        <Container className="p-0 m-0 mb-2" style={{ backgroundColor: 'rgba(222,233,244,1)' }}>
                            <Row className="mt-2 p-0 justify-content-center" style={{ fontSize: "0.875em" }}>
                                <Col className="col-11 p-0 m-0 border border-secondary">
                                    <Row className="d-flex justify-content-left m-0 p-1"
                                        style={{ overflowX: 'auto', marginLeft: 'auto', marginRight: 'auto', maxHeight: 80, backgroundColor: "rgba(245, 250, 255, 1)" }}>
                                        <b>Sprint Groups:&nbsp;</b>
                                        <ButtonGroup>
                                            {sprint
                                                .map(racer => racer.group)
                                                .sort(function (a, b) { return a > b })
                                                .filter((value, index, self) => self.indexOf(value) === index)
                                                .map(group =>
                                                    <Button className="py-0" size="sm" onClick={() => handleSetSprintSituation(selectedStep, group)}
                                                        variant={group === selectedGroup ? 'primary' : 'outline-primary'}>
                                                        {formatTimeSeconds(group)}
                                                    </Button>
                                                )}
                                        </ButtonGroup>
                                    </Row>
                                    <Row className=" d-flex justify-content-center m-0 p-0" style={{ maxHeight: 50, backgroundColor: "rgba(180, 180, 180, 1)" }}>
                                        <b>{(selectedStep * 50) + ' m'}</b>
                                    </Row>
                                    <Row className=" d-flex justify-content-center m-0 p-0" style={{ backgroundColor: "rgba(140, 140, 140, 1)" }}>
                                        <Col ref={sprintRef} className="m-0 p-0"
                                            style={{ overflowX: 'auto', maxHeight: 430, backgroundColor: "rgba(140, 140, 140, 1)", scrollBehavior: 'smooth' }}>
                                            <Stage key={'sprint' + selectedGroup + selectedStep} width={Math.max(((sprintDisplayAttributes.xMax - sprintDisplayAttributes.xMin) / 4) + 48, 996)} height={400}>
                                                <Layer>
                                                    <Line points={[0, 196, Math.max(((sprintDisplayAttributes.xMax - sprintDisplayAttributes.xMin) / 4) + 48, 996), 196]} stroke={'white'} strokeWidth={8} dash={[50, 25]} />
                                                    {sprint
                                                        .filter(sprintRacer => sprintRacer.group === selectedGroup && sprintRacer.positions.some(sp => sp.step === selectedStep))
                                                        .map(sprintRacer => (
                                                            <>
                                                                <RiderImage key={'userJersey' + sprintRacer.id}
                                                                    url={config.DIR_JERSEYS + sprintRacer.jersey}
                                                                    x={(sprintRacer.positions.find(sp => sp.step === selectedStep).positions[sprintAnimation.step].x - sprintDisplayAttributes.xMin) / 4 + Math.max(0, (996 - (((sprintDisplayAttributes.xMax - sprintDisplayAttributes.xMin) / 4) + 48)))}
                                                                    y={(sprintRacer.positions.find(sp => sp.step === selectedStep).positions[sprintAnimation.step].y * 50)}
                                                                    width={48} height={48}
                                                                    riderName={sprintRacer.name.substring(0, 9)}
                                                                    riderSprint={sprintRacer.sprintSkill} />
                                                            </>
                                                        ))}
                                                </Layer>
                                            </Stage>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </>

                    : null
                }

            </Modal.Body>
        </Modal>
    </>
}

export default ReplayModal;